import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f72bec6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "D-Flex W-100",
  style: {"text-align":"left","margin-bottom":"15px","white-space":"nowrap"}
}, null, -1))
const _hoisted_5 = { class: "DialogSection" }
const _hoisted_6 = { class: "W-100 H-100 D-Flex" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_8 = { class: "DialogSection FlexColumn" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "DialogSection FlexColumn"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_12 = { class: "DialogSectionTitle" }
const _hoisted_13 = { class: "DialogSection" }
const _hoisted_14 = {
  key: 0,
  class: "CookiesDialogFooter"
}
const _hoisted_15 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesImageInput = _resolveComponent("CookiesImageInput")!
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_NewPassword = _resolveComponent("NewPassword")!
  const _component_CookiesDropInputObject = _resolveComponent("CookiesDropInputObject")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'CookiesDialog_' + _ctx.DialogIndex,
      class: "CookiesDialogdBody"
    }, [
      (_ctx.Saving)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.Loading.length > 0)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_CookiesImageInput, {
                Placeholder: _ctx.$store.state.CookiesConfig.UserImage,
                Res: 'D_User_ImgUrl'
              }, null, 8, ["Placeholder"])
            ])
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_CookiesNormalInput, {
              Placeholder: _ctx.Translate('Name'),
              CookiesInvalidInput: !(_ctx.MEMRead('D_User_Name') && _ctx.MEMRead('D_User_Name') !== ''),
              ErrorData: _ctx.ErrorsVisibilty && !(_ctx.MEMRead('D_User_Name') && _ctx.MEMRead('D_User_Name') !== ''),
              Res: 'D_User_Name',
              Default: ''
            }, null, 8, ["Placeholder", "CookiesInvalidInput", "ErrorData"]),
            _createVNode(_component_CookiesNormalInput, {
              class: _normalizeClass([_ctx.DialogData.Editing ? 'Disabled': '']),
              Placeholder: _ctx.Translate('Email'),
              CookiesInvalidInput: !_ctx.EmailValidator(_ctx.MEMRead('D_User_Email')),
              ErrorData: _ctx.ErrorsVisibilty && !_ctx.EmailValidator(_ctx.MEMRead('D_User_Email')),
              Res: 'D_User_Email',
              Default: ''
            }, null, 8, ["class", "Placeholder", "CookiesInvalidInput", "ErrorData"])
          ]),
          _hoisted_9,
          (!_ctx.DialogData.Editing || _ctx.Access('Security_ChangeAllPasswords'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_NewPassword, {
                  class: "FlexColumn",
                  onChangePassword: _ctx.ChangePassword,
                  Res: 'D_User_Password',
                  ErrorsVisibilty: _ctx.ErrorsVisibilty,
                  Editing: _ctx.DialogData.Editing
                }, null, 8, ["onChangePassword", "ErrorsVisibilty", "Editing"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.Translate('Assign Profile')), 1),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_CookiesDropInputObject, {
              Name: _ctx.Translate('Profile'),
              CookiesInvalidInput: !(_ctx.MEMRead('D_User_Profile') && _ctx.MEMRead('D_User_Profile') !== ''),
              ErrorData: _ctx.ErrorsVisibilty && !(_ctx.MEMRead('D_User_Profile') && _ctx.MEMRead('D_User_Profile') !== ''),
              Res: 'D_User_Profile',
              Options: _ctx.Profiles,
              Selectors: ['Name']
            }, null, 8, ["Name", "CookiesInvalidInput", "ErrorData", "Options"])
          ])
        ])
      ])
    ], 8, _hoisted_1),
    (_ctx.Access(_ctx.DialogData.Editing ? 'Security_Profiles_Edit': 'Security_Profiles_Create'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Cancel')), 1),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args))),
              style: _normalizeStyle('background: ' + _ctx.Theme.UserColors.main),
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Save')), 5)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}